import React, { useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import PSIcon from './PSIcon';
import { verifyPath } from '../../scripts/Helper';

const StyledPSASideBar = styled.div`
  width: 100%;
  height: 100%;

  .container-menu {
    margin: 15px 20px;
    .menu {
      margin: 1rem 1rem 2.5rem 1rem;
      .section-title {
        color: #f14b4b;
        text-align: left;
        font-size: 21px;
      }
      .item-selected {
        p {
          color: #f14b4b;
        }
        .icon-title svg .a-construct {
          fill: #f14b4b !important;
        }
      }
      .section-item {
        color: #002655;
        cursor: pointer;
        font-size: 14px;
        .item-title {
          display: flex;
          align-items: center;
          .icon-title {
            padding-right: 10px;
          }
          .icon-arrow {
            padding-left: 20px;
          }
        }

        .section-item-option {
          padding: 0.5rem;
          cursor: pointer;
          li {
            list-style: none;
          }
          li:before {
            content: '• ';
            color: #de6d19;
            font-size: 22px;
          }
        }
        .selected {
          color: #de6d19;
          background: #fae9dd;
          border-radius: 17px;
        }
      }
    }
  }
`;

const PSAsideBar = ({ menuSidebar }) => {
  const [currentOption, setCurrentOption] = useState({});
  const history = useHistory();

  const selectMenu = (firstIndex, SecondIndex, url) => {
    if (!url) {
      if (SecondIndex === currentOption[firstIndex]) {
        setCurrentOption({});
      } else {
        currentOption[firstIndex] = SecondIndex;
        setCurrentOption({ ...currentOption });
      }
    }
    history.push(url);
  };
  const goToPage = (item) => {
    history.push(item.url);
  };

  return (
    <StyledPSASideBar>
      <div className="container-menu">
        {menuSidebar.map((menu, fIndex) => (
          <div key={menu.id} className="menu">
            <div className="section-title">
              <p>{menu.nameMenu}</p>
            </div>
            {menu.menu.map((opt, SIndex) => {
              const hasPath = verifyPath(history, opt.url);
              return (
                <div key={opt.id} className="section-item pointer">
                  <div
                    className={`item-title${hasPath ? ' item-selected' : ' '}`}
                    onClick={() => selectMenu(fIndex, SIndex, opt.url)}
                  >
                    {opt.icon && <PSIcon type={opt.icon} className="icon-title" />}
                    <p>{opt.title}</p>
                  </div>
                  <div>
                    {opt.options.map((item) => (
                      <div
                        key={item.id}
                        className="section-item-option"
                        onClick={() => goToPage(item)}
                      >
                        <li>{item.description}</li>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
        <div />
      </div>
    </StyledPSASideBar>
  );
};

PSAsideBar.propTypes = {};

export default PSAsideBar;
